import { ref, computed, type Ref } from "vue";

export function useImage(
  src: Ref<string | undefined>,
  fallbackImage?: Ref<string>,
) {
  const isError = ref<boolean>(false);
  const isLoading = ref<boolean>(false);

  const isVisible = computed(() => src.value?.length && !isLoading.value);

  const imgSrc = computed(() => {
    if (isError.value || !isVisible.value) {
      return fallbackImage?.value;
    } else {
      return src.value;
    }
  });

  async function loadImage() {
    isLoading.value = true;
    isError.value = false;

    try {
      if (src.value) {
        const img = new Image();

        const promises = [
          new Promise<void>((resolve) => setTimeout(resolve, 900)),
          new Promise<void>((resolve, reject) => {
            img.onload = () => resolve();
            img.onerror = (e) => reject(e);
          }),
        ];

        img.src = src.value;

        await Promise.all(promises);
      }
    } catch (e) {
      isError.value = true;
    } finally {
      isLoading.value = false;
    }
  }

  return {
    isVisible,
    isLoading,
    isError,
    loadImage,
    imgSrc,
  };
}